/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Clubs_Round_DatesInputs */

const en_us2_clubs_round_dates = /** @type {(inputs: Clubs_Round_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.start} to ${i?.end}`)
};

const pt_br2_clubs_round_dates = /** @type {(inputs: Clubs_Round_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.start} a ${i?.end}`)
};

const es_419_clubs_round_dates = /** @type {(inputs: Clubs_Round_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.start} a ${i?.end}`)
};

const pt_pt2_clubs_round_dates = /** @type {(inputs: Clubs_Round_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.start} a ${i?.end}`)
};

const fr_fr2_clubs_round_dates = /** @type {(inputs: Clubs_Round_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du ${i?.start} au ${i?.end}`)
};

const de_de2_clubs_round_dates = /** @type {(inputs: Clubs_Round_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.start} bis ${i?.end}`)
};

const it_it2_clubs_round_dates = /** @type {(inputs: Clubs_Round_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dal ${i?.start} al ${i?.end}`)
};

/**
* | output |
* | --- |
* | "{start} to {end}" |
*
* @param {Clubs_Round_DatesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_round_dates = /** @type {((inputs: Clubs_Round_DatesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Round_DatesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_round_dates(inputs)
	if (locale === "es-419") return es_419_clubs_round_dates(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_round_dates(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_round_dates(inputs)
	if (locale === "de-DE") return de_de2_clubs_round_dates(inputs)
	if (locale === "it-IT") return it_it2_clubs_round_dates(inputs)
	return en_us2_clubs_round_dates(inputs)
});
export { clubs_round_dates as "clubs.round_dates" }